export default "__VITE_ASSET__918bf709__"